import { HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '@alfresco/adf-core';

/**
 * En-tete `Authorization` pour les appels REST de l'extension Collabora.
 *
 * Volontairement duplique depuis `alg-extensions/src/lib/alg-auth.ts` : cette extension doit
 * rester autonome et ne pas dependre de nos extensions metier, pour pouvoir etre publiee ou
 * remplacee par une extension communautaire sans autre modification.
 *
 * On delegue a `AuthenticationService.getAuthHeaders()` (gere OIDC et Basic, maintenu par ADF)
 * plutot que de reimplementer la logique : ADF 6.7.1 a supprime `getTicketEcmBase64()`.
 */
export function collaboraAuthorizationHeader(auth: AuthenticationService, requestUrl: string = window.location.origin): string {
  return auth.getAuthHeaders(requestUrl, new HttpHeaders()).get('Authorization') ?? '';
}
